import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { getAIProtonProducts } from "@NA/Widgets/AIProton/AIProtonService";
import { GetAIProtonApiParameter } from "@NA/Widgets/AIProton/AIProtonModel";
import AIProtonState, { createFromProduct } from "@NA/Widgets/AIProton/AIProtonState";
import { pushDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";
import {
    getProductCollectionRealTimeInventory,
    getProductCollectionRealTimePrices,
} from "@insite/client-framework/Services/ProductServiceV2";

type HandlerType = CustomApiHandler<GetAIProtonApiParameter, AIProtonState>;

export const DispatchAIProtonLoading: HandlerType = (props: any) => {
    props.dispatch({
        type: "HomePage/GetAIProton",
        result: props.parameter,
    });
};

export const LoadAIProtonProducts: HandlerType = async (props: any) => {
    let response = {};
    try {
        response = await getAIProtonProducts({ userID: props.parameter.userID, productID: props.parameter.productID, Scenario: props.parameter.Scenario });
    } catch (error) { /* empty */ }

    props.apiResult = { ...response };

    if (props.apiResult && props.apiResult.products != null && props.apiResult.products.length) {
        const productInfos = [];
        for (const product of props.apiResult.products) {
            productInfos.push(createFromProduct(product));
        }
        const pricing = await getProductCollectionRealTimePrices({ productPriceParameters: productInfos });
        // const inventory = await getProductCollectionRealTimeInventory({
        //     productIds: productInfos.map((o: any) => o.productId),
        // });
        const products = checkPriceBasedOnProdutId(
            props.apiResult.products,
            pricing.realTimePricingResults,
            // inventory.realTimeInventoryResults,
        );
        props.apiResult.products = products;
        SendTrackingCustom(props, pricing);
    } else {
        props.apiResult.products = [];
    }
};

export const DispatchCompleteLoadAIProton: HandlerType = props => {
    props.dispatch({
        type: props.parameter.dispatch,
        products: props.apiResult.products,
        productsFBT: props.apiResult.products,
        productsSimilar: props.apiResult.products,
    } as any);
};
function SendTrackingCustom(props: any, realTimePricing: RealTimePricingModel) {
    const products = props.apiResult.products;
    const widgetName = props.parameter.widgetName
    if (products && products.length > 0) {
        window.localStorage.setItem("itemListName", widgetName);
        pushDataToDataLayer(products, widgetName, props.getState().context.session, realTimePricing);
    }
}
export const chain = [DispatchAIProtonLoading, LoadAIProtonProducts, DispatchCompleteLoadAIProton];

const loadAIProton = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        userID: "",
        productID: "",
        Scenario: "",
        widgetName: "",
    },
    "loadAIProton",
);
export default loadAIProton;

const checkPriceBasedOnProdutId = (products: any, realTimePricing: any,) => {
    if (products && products.length > 1 && realTimePricing && realTimePricing.length > 1) {
        products.map((pro: any) => {
            if (getCurrentProductPricing(realTimePricing, pro.id)) {
                pro.pricing = getCurrentProductPricing(realTimePricing, pro.id);
                // pro.inventory = getCurrentProductInventory(products, pro.id);
            }
        });
        return products;
    }
};

const getCurrentProductPricing = (products: any, id: string) => {
    if (products.length > 0) {
        const currentPricing = products.find((pro: any) => pro.productId === id);
        if (currentPricing) {
            return currentPricing;
        }
        return false;
    }
    return false;
};

const getCurrentProductInventory = (inventoryProducts: any, id: string) => {
    if (inventoryProducts.length > 0) {
        const currentInventory = inventoryProducts.find((pro: any) => pro.productId === id);
        if (currentInventory) {
            return currentInventory;
        }
        return false;

    }
    return false;

};
